/**
 * Preserve native-feeling scroll position on reload and history navigation.
 */
(function () {
  const restoreState = window.__saScrollRestore || {};
  const storageKey = restoreState.storageKey || `sa-scroll-position:${window.location.pathname}${window.location.search}`;
  const maxRestoreAttempts = 12;
  let restoreAttempts = 0;
  let pageShown = false;

  function readScrollTop() {
    return window.scrollY || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
  }

  function showPage() {
    if (pageShown) return;
    pageShown = true;
    document.documentElement.classList.remove('sa-scroll-restoring');
    window.dispatchEvent(new CustomEvent('sa:scroll-restore-ready'));
  }

  function saveScrollPosition() {
    try {
      window.sessionStorage.setItem(storageKey, String(readScrollTop()));
    } catch (error) {
      // Ignore storage errors, such as private browsing restrictions.
    }
  }

  function restoreScrollPosition() {
    if (!restoreState.shouldRestore || !restoreState.savedScrollTop) {
      showPage();
      return;
    }

    const savedScrollTop = restoreState.savedScrollTop;

    function restoreFrame() {
      restoreAttempts += 1;

      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(savedScrollTop, { immediate: true, force: true });
      } else {
        window.scrollTo(0, savedScrollTop);
      }

      if (restoreAttempts === 2) showPage();

      if (restoreAttempts < maxRestoreAttempts) {
        requestAnimationFrame(restoreFrame);
      } else {
        showPage();
      }
    }

    restoreFrame();
  }

  window.addEventListener('pagehide', saveScrollPosition);
  window.addEventListener('beforeunload', saveScrollPosition);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScrollPosition, { once: true });
  } else {
    restoreScrollPosition();
  }
})();
